export const PERMISSIONS = {
	CAN_VIEW: "CAN_VIEW",
	CAN_VIEW_DETAILS: "CAN_VIEW_DETAILS",
	CAN_CREATE: "CAN_CREATE",
	CAN_EDIT: "CAN_EDIT",
	CAN_RESPOND: "CAN_RESPOND",
	CAN_VIEW_AUDIT_LOG: "CAN_VIEW_AUDIT_LOG",
	CAN_VIEW_GENERAL: "CAN_VIEW_GENERAL",
	CAN_VIEW_TRANSACTIONS: "CAN_VIEW_TRANSACTIONS",
	CAN_WRITE_OPINION: "CAN_WRITE_OPINION",
	WRITE_OPINION_DISPATCH: "WRITE_OPINION_DISPATCH",
	SECTION_OPINION_REVIEW: "SECTION_OPINION_REVIEW",
	DEPARTMENT_OPINION_REVIEW: "DEPARTMENT_OPINION_REVIEW",
	ENDORSEMENT_WRITE_OPINION: "ENDORSEMENT_WRITE_OPINION",
	RECORDS_CAN_CREATE: "RECORDS_CAN_CREATE",
	RECORDS_DISPATCH: "RECORDS_DISPATCH",
	RECORDS_DEPARTMENT_REVIEW: "RECORDS_DEPARTMENT_REVIEW",
	RECORDS_ENDORSEMENT_REVIEW: "RECORDS_ENDORSEMENT_REVIEW",
	SESSIONS_RECORDS_CHAIRMAN_MANAGE: "SESSIONS_RECORDS_CHAIRMAN_MANAGE",
	SESSIONS_RECORDS_MANAGE: "SESSIONS_RECORDS_MANAGE",

	FAQ_CAN_VIEW: "FAQ_CAN_VIEW",
	FAQ_CAN_CREATE: "FAQ_CAN_CREATE",
	FAQ_CAN_EDIT: "FAQ_CAN_EDIT",
	FAQ_CAN_VIEW_DETAILS: "FAQ_CAN_VIEW_DETAILS",

	SESSIONS_CAN_CREATE: "SESSIONS_CAN_CREATE",
	SESSIONS_DISPATCH: "SESSIONS_DISPATCH",

	DECISION_CAN_CREATE: "DECISION_CAN_CREATE",
	DECISION_DISPATCH: "DECISION_DISPATCH",
	DECISION_DEPARTMENT_REVIEW: "DECISION_DEPARTMENT_REVIEW",
	DECISION_ENDORSEMENT_REVIEW: "DECISION_ENDORSEMENT_REVIEW",

	DECISION_ISSUING_FINAL_DECISION: "DECISION_ISSUING_FINAL_DECISION",
	REPORTS_CAN_VIEW: "REPORTS_CAN_VIEW",
	CAN_VIEW_LAWSUITS: "CAN_VIEW_LAWSUITS",
	CAN_VIEW_INTERNAL_USERS: "CAN_VIEW_INTERNAL_USERS",
	CAN_VIEW_BENEFICIARIES: "CAN_VIEW_BENEFICIARIES",
	CAN_VIEW_NOTICES: "CAN_VIEW_NOTICES",
	CAN_VIEW_PROFESSIONAL_MONITORING: "CAN_VIEW_PROFESSIONAL_MONITORING",
	CAN_VIEW_STATISTICS: "CAN_VIEW_STATISTICS",
	CAN_VIEW_SMS_LOGS: "CAN_VIEW_SMS_LOGS",
	CAN_VIEW_LAWYERS: "CAN_VIEW_LAWYERS",
	CAN_VIEW_BUSINESS: "CAN_VIEW_BUSINESS",
	CAN_VIEW_GOVERNMENT: "CAN_VIEW_GOVERNMENT",
	CAN_EXPORT: "CAN_EXPORT",

	CAN_VIEW_ROLES: "CAN_VIEW_ROLES",
	CAN_RESET_PASSWORD: "CAN_RESET_PASSWORD",
	CAN_MANAGE: "CAN_MANAGE",

	CAN_VIEW_ALL: "CAN_VIEW_ALL",
	CAN_VIEW_ASSIGNED: "CAN_VIEW_ASSIGNED",
	CAN_VIEW_OWN: "CAN_VIEW_OWN",
	CAN_VIEW_AGAINST: "CAN_VIEW_AGAINST",
	CAN_VIEW_RANDOM_REFERRAL: "CAN_VIEW_RANDOM_REFERRAL",
	CAN_STUDY: "CAN_STUDY",
	CAN_REVIEW: "CAN_REVIEW",
	CAN_APPROVE: "CAN_APPROVE",
	CAN_FINAL_APPROVE: "CAN_FINAL_APPROVE",
	CAN_REFER: "CAN_REFER",
	CAN_REQUEST_DOCUMENTS: "CAN_REQUEST_DOCUMENTS",
	CAN_LOOKUP_BY_REF: "CAN_LOOKUP_BY_REF",
	CAN_RECEIVE: "CAN_RECEIVE",

	COMPLAINTS_CAN_VIEW_ALL: "COMPLAINTS.CAN_VIEW_ALL",
	NOTICES_CAN_VIEW_ALL: "NOTICES.CAN_VIEW_ALL",
	PROFESSIONAL_MONITORING_CAN_VIEW_ALL: "MONITORING.CAN_VIEW_ALL",
} as const;

export const PERMISSION_FEATURES = {
	DASHBOARD: "DASHBOARD",
	AUDIT_LOG: "AUDIT_LOG",
	LAWSUITS: "LAWSUITS",
	NOTES: "NOTES",
	NOTICES: "NOTICES",
	PROFESSIONAL_MONITORING: "PROFESSIONAL_MONITORING",
	MONITORING: "MONITORING",
	ACCOUNT_REQUESTS: "ACCOUNT_REQUESTS",
	USERS: "USERS",
	REFERRAL: "REFERRAL",
	TRANSACTION_AGE: "TRANSACTION_AGE",
	REPORTS: "REPORTS",
	FAQ: "FAQ",
	PROFILE: "PROFILE",
	NOTIFICATIONS: "NOTIFICATIONS",
	SETTINGS: "SETTINGS",
	COMPLAINTS: "COMPLAINTS",
	HOLIDAYS_MANAGEMENT: "HOLIDAYS_MANAGEMENT",
	FEEDBACK: "FEEDBACK",
} as const;

export type PermissionFeature = (typeof PERMISSION_FEATURES)[keyof typeof PERMISSION_FEATURES];

export const PERMISSION_CODES = {
	DASHBOARD_CAN_VIEW: "DASHBOARD.CAN_VIEW",

	LAWSUITS_CAN_VIEW: "LAWSUITS.CAN_VIEW",
	LAWSUITS_CAN_VIEW_DETAILS: "LAWSUITS.CAN_VIEW_DETAILS",
	LAWSUITS_CAN_CREATE: "LAWSUITS.CAN_CREATE",
	LAWSUITS_CAN_VIEW_ASSIGNED: "LAWSUITS.CAN_VIEW_ASSIGNED",
	LAWSUITS_CAN_VIEW_SAVED: "LAWSUITS.CAN_VIEW_SAVED",
	LAWSUITS_CAN_LOOKUP_BY_REF: "LAWSUITS.CAN_LOOKUP_BY_REF",
	LAWSUITS_CAN_VIEW_AUDIT_LOG: "LAWSUITS.CAN_VIEW_AUDIT_LOG",
	AUDIT_LOG_CAN_VIEW_AUDIT_LOG: "AUDIT_LOG.CAN_VIEW_AUDIT_LOG",
	AUDIT_LOG_CAN_VIEW: "AUDIT_LOG.CAN_VIEW",
	AUDIT_LOG_CAN_VIEW_GENERAL: "AUDIT_LOG.CAN_VIEW_GENERAL_ACTIONS",
	AUDIT_LOG_CAN_VIEW_TRANSACTIONS: "AUDIT_LOG.CAN_VIEW_TRANSACTION_ACTIONS",
	AUDIT_LOG_CAN_EXPORT: "AUDIT_LOG.CAN_EXPORT",
	COMPLAINTS_CAN_VIEW_ALL: "COMPLAINTS.CAN_VIEW_ALL",
	REFERRAL_CAN_VIEW: "REFERRAL.CAN_VIEW",
	REFERRAL_CAN_CREATE: "REFERRAL.CAN_CREATE",

	NOTES_CAN_VIEW: "NOTES.CAN_VIEW",
	NOTES_CAN_CREATE: "NOTES.CAN_CREATE",
	NOTES_CAN_VIEW_DETAILS: "NOTES.CAN_VIEW_DETAILS",
	NOTES_CAN_VIEW_ASSIGNED: "NOTES.CAN_VIEW_ASSIGNED",
	NOTES_CAN_VIEW_SAVED: "NOTES.CAN_VIEW_SAVED",
	NOTICES_CAN_VIEW_ALL: "NOTICES.CAN_VIEW_ALL",

	PM_CAN_VIEW: "PROFESSIONAL_MONITORING.CAN_VIEW",
	PM_CAN_CREATE: "PROFESSIONAL_MONITORING.CAN_CREATE",
	PM_CAN_VIEW_DETAILS: "PROFESSIONAL_MONITORING.CAN_VIEW_DETAILS",
	PM_CAN_VIEW_ASSIGNED: "PROFESSIONAL_MONITORING.CAN_VIEW_ASSIGNED",
	PM_CAN_VIEW_SAVED: "PROFESSIONAL_MONITORING.CAN_VIEW_SAVED",
	PM_CAN_VIEW_AUDIT_LOG: "PROFESSIONAL_MONITORING.CAN_VIEW_AUDIT_LOG",
	MONITORING_CAN_VIEW_ALL: "MONITORING.CAN_VIEW_ALL",
	NOTES_CAN_VIEW_AUDIT_LOG: "NOTES.CAN_VIEW_AUDIT_LOG",

	REPORTS_CAN_VIEW: "REPORTS.CAN_VIEW",
	REPORTS_CAN_VIEW_LAWSUITS: "REPORTS.CAN_VIEW_LAWSUITS",
	REPORTS_CAN_VIEW_NOTICES: "REPORTS.CAN_VIEW_NOTICES",
	REPORTS_CAN_VIEW_PROFESSIONAL_MONITORING: "REPORTS.CAN_VIEW_PROFESSIONAL_MONITORING",
	REPORTS_CAN_VIEW_USERS: "REPORTS.CAN_VIEW_USERS",
	REPORTS_CAN_VIEW_INTERNAL_USERS: "REPORTS.CAN_VIEW_INTERNAL_USERS",
	REPORTS_CAN_VIEW_BENEFICIARIES: "REPORTS.CAN_VIEW_BENEFICIARIES",
	REPORTS_CAN_VIEW_LAWYERS: "REPORTS.CAN_VIEW_LAWYERS",
	REPORTS_CAN_VIEW_BUSINESS: "REPORTS.CAN_VIEW_BUSINESS",
	REPORTS_CAN_VIEW_GOVERNMENT: "REPORTS.CAN_VIEW_GOVERNMENT",
	REPORTS_CAN_VIEW_STATISTICS: "REPORTS.CAN_VIEW_STATISTICS",
	REPORTS_CAN_VIEW_REQUESTS_STATUS: "REPORTS.CAN_VIEW_REQUESTS_STATUS",
	REPORTS_CAN_VIEW_SMS_LOGS: "REPORTS.CAN_VIEW_SMS_LOGS",
	REPORTS_CAN_VIEW_SAVED_REQUESTS: "REPORTS.CAN_VIEW_SAVED_REQUESTS",
	REPORTS_CAN_VIEW_REFERRED_TO_DEPARTMENT: "REPORTS.CAN_VIEW_REFERRED_TO_DEPARTMENT",
	REPORTS_CAN_VIEW_UNDER_REVIEW: "REPORTS.CAN_VIEW_UNDER_REVIEW",
	REPORTS_CAN_VIEW_REFERRED_TO_POLICE: "REPORTS.CAN_VIEW_REFERRED_TO_POLICE",
	REPORTS_CAN_VIEW_AWAITING_STATEMENT: "REPORTS.CAN_VIEW_AWAITING_STATEMENT",
	REPORTS_CAN_VIEW_AWAITING_REQUIREMENTS: "REPORTS.CAN_VIEW_AWAITING_REQUIREMENTS",
	REPORTS_CAN_EXPORT: "REPORTS.CAN_EXPORT",

	USERS_CAN_VIEW: "USERS.CAN_VIEW",
	USERS_CAN_VIEW_DETAILS: "USERS.CAN_VIEW_DETAILS",
	USERS_CAN_EDIT: "USERS.CAN_EDIT",
	USERS_CAN_CREATE: "USERS.CAN_CREATE",
	USERS_CAN_VIEW_ROLES: "USERS.CAN_VIEW_ROLES",
	USERS_CAN_RESET_PASSWORD: "USERS.CAN_RESET_PASSWORD",

	PROFILE_CAN_VIEW: "PROFILE.CAN_VIEW",
	PROFILE_CAN_EDIT: "PROFILE.CAN_EDIT",
	PROFILE_CAN_CHANGE_PASSWORD: "PROFILE.CAN_CHANGE_PASSWORD",

	ACCOUNT_REQUESTS_CAN_VIEW: "ACCOUNT_REQUESTS.CAN_VIEW",
	ACCOUNT_REQUESTS_CAN_VIEW_DETAILS: "ACCOUNT_REQUESTS.CAN_VIEW_DETAILS",
	ACCOUNT_REQUESTS_CAN_RESPOND: "ACCOUNT_REQUESTS.CAN_RESPOND",
	TRANSACTION_AGE_CAN_VIEW: "TRANSACTION_AGE.CAN_VIEW",
	HOLIDAYS_MANAGEMENT_CAN_VIEW: "HOLIDAYS_MANAGEMENT.CAN_VIEW",

	FEEDBACK_CAN_VIEW: "FEEDBACK.CAN_VIEW",
	FEEDBACK_CAN_VIEW_DETAILS: "FEEDBACK.CAN_VIEW_DETAILS",
	FEEDBACK_CAN_RESPOND: "FEEDBACK.CAN_RESPOND",
	FEEDBACK_CAN_CREATE: "FEEDBACK.CAN_CREATE",
} as const;

export type PermissionCode = (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES];

export const EXTERNAL_CREATE_PERMISSION_CODES = [PERMISSION_CODES.LAWSUITS_CAN_CREATE, PERMISSION_CODES.NOTES_CAN_CREATE] as const;

export const EXTERNAL_VIEW_PERMISSION_CODES = [
	PERMISSION_CODES.LAWSUITS_CAN_VIEW,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_DETAILS,
] as const;

export const EXTERNAL_GRANTABLE_PERMISSION_CODES = [
	...EXTERNAL_VIEW_PERMISSION_CODES,
	...EXTERNAL_CREATE_PERMISSION_CODES,
	PERMISSION_CODES.PROFILE_CAN_VIEW,
	PERMISSION_CODES.PROFILE_CAN_EDIT,
] as const;

export const LAWSUITS_LIST_VIEW_ACTIONS = [
	PERMISSION_CODES.LAWSUITS_CAN_VIEW,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_SAVED,
	PERMISSION_CODES.COMPLAINTS_CAN_VIEW_ALL,
] as const;

export const LAWSUITS_DETAILS_VIEW_ACTIONS = [PERMISSION_CODES.LAWSUITS_CAN_VIEW_DETAILS] as const;

export const NOTES_LIST_VIEW_ACTIONS = [
	PERMISSION_CODES.NOTES_CAN_VIEW,
	PERMISSION_CODES.NOTES_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.NOTES_CAN_VIEW_SAVED,
	PERMISSION_CODES.NOTICES_CAN_VIEW_ALL,
] as const;

export const NOTES_DETAILS_VIEW_ACTIONS = [PERMISSION_CODES.NOTES_CAN_VIEW_DETAILS] as const;

export const PM_LIST_VIEW_ACTIONS = [
	PERMISSION_CODES.PM_CAN_VIEW,
	PERMISSION_CODES.PM_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.PM_CAN_VIEW_SAVED,
	PERMISSION_CODES.MONITORING_CAN_VIEW_ALL,
] as const;

export const PM_DETAILS_VIEW_ACTIONS = [PERMISSION_CODES.PM_CAN_VIEW_DETAILS] as const;

export const USERS_CREATE_OR_EDIT_ACTIONS = [PERMISSION_CODES.USERS_CAN_CREATE, PERMISSION_CODES.USERS_CAN_EDIT] as const;

export const USERS_LIST_ACTIONS = [
	PERMISSION_CODES.USERS_CAN_VIEW,
	PERMISSION_CODES.USERS_CAN_VIEW_DETAILS,
	PERMISSION_CODES.USERS_CAN_CREATE,
	PERMISSION_CODES.USERS_CAN_EDIT,
	PERMISSION_CODES.USERS_CAN_RESET_PASSWORD,
] as const;

export const REFERRAL_PAGE_ACTIONS = [PERMISSION_CODES.REFERRAL_CAN_CREATE, PERMISSION_CODES.LAWSUITS_CAN_LOOKUP_BY_REF] as const;

export const AUDIT_LOG_VIEW_ACTIONS = [
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_AUDIT_LOG,
	PERMISSION_CODES.NOTES_CAN_VIEW_AUDIT_LOG,
	PERMISSION_CODES.PM_CAN_VIEW_AUDIT_LOG,
] as const;

export const AUDIT_LOG_PAGE_ACTIONS = [
	PERMISSION_CODES.AUDIT_LOG_CAN_VIEW,
	PERMISSION_CODES.AUDIT_LOG_CAN_VIEW_GENERAL,
	PERMISSION_CODES.AUDIT_LOG_CAN_VIEW_TRANSACTIONS,
] as const;

export const AUDIT_LOG_TRANSACTIONS_ACTIONS = [PERMISSION_CODES.AUDIT_LOG_CAN_VIEW_TRANSACTIONS] as const;

export const AUDIT_LOG_GENERAL_ACTIONS = [PERMISSION_CODES.AUDIT_LOG_CAN_VIEW_GENERAL] as const;

export const AUDIT_LOG_EXPORT_ACTIONS = [PERMISSION_CODES.AUDIT_LOG_CAN_EXPORT] as const;

export const COMPLAINTS_AUDIT_LOG_VIEW_ACTIONS = [PERMISSION_CODES.LAWSUITS_CAN_VIEW_AUDIT_LOG] as const;
export const NOTICES_AUDIT_LOG_VIEW_ACTIONS = [PERMISSION_CODES.NOTES_CAN_VIEW_AUDIT_LOG] as const;
export const MONITORING_AUDIT_LOG_VIEW_ACTIONS = [PERMISSION_CODES.PM_CAN_VIEW_AUDIT_LOG] as const;

export type PermissionInput = string | readonly string[] | null | undefined;

export function toPermissionCode(feature: string, action: string): string {
	return `${feature}.${action}`;
}

export function splitPermissionCode(code: string): { feature: string; action: string } | null {
	const dot = code.indexOf(".");
	if (dot <= 0 || dot === code.length - 1) return null;
	return { feature: code.slice(0, dot), action: code.slice(dot + 1) };
}
